import { render, staticRenderFns } from "./FilterBrands.vue?vue&type=template&id=bd053d58"
import script from "./FilterBrands.vue?vue&type=script&lang=js"
export * from "./FilterBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports